// for images loaded via `file-loader`
__webpack_public_path__ = JsCoq.base_path + 'dist-webpack/addon/';
